import type { CredentialType } from '@seek/ca-myprofile-utils';

import type {
  Store,
  AnalyticsService,
  AnalyticsLicenceInfo,
  AnalyticsCurrentPageSection,
} from '../types';

import type { CertsyLinkAction, CertsyLinkPosition } from './eventNames';

const CERTSY_STATUS = ['verified', 'unverified'] as const;

type CertsyStatus = (typeof CERTSY_STATUS)[number];

const eventName: Record<
  CertsyLinkAction,
  | 'certsy_learn_more_pressed'
  | 'certsy_manage_pressed'
  | 'certsy_verify_pressed'
  | 'profile_update_succeeded'
> = {
  ['learn more']: 'certsy_learn_more_pressed',
  ['manage']: 'certsy_manage_pressed',
  ['verify']: 'certsy_verify_pressed',
  ['delete']: 'profile_update_succeeded',
};

const credentialTypeToAnalyticsType = (credentialType: CredentialType) =>
  credentialType
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();

export const createCertsyAnalytics = (
  store: Store,
  analyticsService: AnalyticsService,
) => {
  const { getState } = store;

  const certsyLinkClicked = ({
    urlLink,
    linkAction,
    linkPosition,
    certsyStatus,
    credentialType,
    currentPageSection,
    analyticsLicenceInfo,
  }: {
    urlLink?: string;
    linkAction: CertsyLinkAction;
    linkPosition: CertsyLinkPosition;
    credentialType: CredentialType;
    certsyStatus?: CertsyStatus;
    currentPageSection: AnalyticsCurrentPageSection;
    analyticsLicenceInfo?: AnalyticsLicenceInfo;
  }) => {
    analyticsService.link(eventName[linkAction], {
      ...getState(),
      eventName: eventName[linkAction],
      currentPageSection,
      certsyType: credentialTypeToAnalyticsType(credentialType),
      linkPosition,
      ...(certsyStatus && { certsyStatus }),
      ...(urlLink && { urlLink }),
      ...analyticsLicenceInfo,
    });
  };

  return {
    certsyLinkClicked,
  };
};

export type CertsyAnalytics = ReturnType<typeof createCertsyAnalytics>;
